module.exports = __webpack_public_path__ + "Starred-items_teal.b52d38ba364c2afceeaf.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/Starred-items_teal.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/Starred-items_teal.svg
// module chunks = styles